
export interface ResumeSGChargeEntity {
    id: number,
    dtlState: string,
    seqNo: string,
    billToCompany: string,
    chargeOnCompany: string,
    chargeType: string,
    subChargeType: string,
    cntrNo: string,
    opsDate: Date | null,
    consortiumCode: string,
    vesselCode: string,
    voyageCode: string,
    etd: Date | null,
    vesselName: string,
    tariffType: string,
    tariffCode: string,
    qty: number | null,
    uom: string,
    chargingFromDateTime: Date | null,
    chargingToDateTime: Date | null,
    opsLine: string,
    dataReferenceType: string,
    isSystemChg?: boolean | false,
    isCreditChg?: boolean | false,
    isManualChg?: boolean | false,

    [key: string]: string | number | Date | boolean | null | undefined
}

export const EMPTY_RESUME_SG_CHARGE_ENTITY: ResumeSGChargeEntity = {
    id: 0,
    dtlState: "",
    seqNo: "",
    billToCompany: "",
    chargeOnCompany: "",
    chargeType: "",
    subChargeType: "",
    cntrNo: "",
    opsDate: null,
    consortiumCode: "",
    vesselCode: "",
    voyageCode: "",
    etd: null,
    vesselName: "",
    tariffType: "",
    tariffCode: "",
    qty: null,
    uom: "",
    chargingFromDateTime: null,
    chargingToDateTime: null,
    opsLine: "",
    dataReferenceType: "",
    isSystemChg: false,
    isCreditChg: false,
    isManualChg: false
}